import { ConversationItem, ConversationTypeEnum, MessageItem } from '@appTypes/chat-api.types';
import { DataLoadStatusModel } from '@core/store/store.models';
import { iif, insertItem, patch, StateOperator, updateItem } from '@ngxs/store/operators';
import { uniqueId } from 'lodash-es';
import { ChatOpenConversationParams } from '../chat.type';
import { ChatBoxModel, ChatMessageModel, ChatStateModel, ConversationsListModel } from './chat.model';

export const patchChatBoxMessage = (conversationId: string, stateOperator: StateOperator<ChatMessageModel[]>) =>
  patch<ChatStateModel>({
    chatBoxes: updateItem<ChatBoxModel>(
      (c) => c.conversationId === conversationId,
      patch<ChatBoxModel>({
        messages: stateOperator
      })
    )
  });

export const upsertChatBoxMessage = (message: MessageItem, beforePosition?: number) => {
  const messageModel: ChatMessageModel = {
    item: message,
    ts: message.senderTimestamp,
    loadState: new DataLoadStatusModel('completed'),
    messageId: message._id
  };
  return patchChatBoxMessage(
    message.conversationId,
    iif<ChatMessageModel[]>(
      (_c) => Boolean(_c?.some((m) => m.messageId === message._id)),
      updateItem((m) => m?.messageId === message._id, patch(messageModel)), //
      insertItem(messageModel, beforePosition)
    )
  );
};

export const upsertChatBox = (chatBox: ChatBoxModel) =>
  patch<ChatStateModel>({
    chatBoxes: iif<ChatBoxModel[]>(
      (_c) => Boolean(_c?.some((m) => m.id === chatBox.id)),
      updateItem((c) => c.id === chatBox.id, patch(chatBox)), //
      insertItem(chatBox, chatBox?.messages?.length ?? 0)
    )
  });

export const setLastMessageOnConversation = (message: MessageItem) =>
  patch<ChatStateModel>({
    conversationsList: patch<ConversationsListModel>({
      items: updateItem<ConversationItem>(
        (c) => c._id === message.conversationId,
        patch<ConversationItem>({
          lastMessage: message
        })
      )
    })
  });

export const updateConversation = (conversation: ConversationItem) =>
  patch<ChatStateModel>({
    conversationsList: patch<ConversationsListModel>({
      items: updateItem<ConversationItem>(
        (c) => c._id === conversation._id,
        patch<ConversationItem>({ ...conversation })
      )
    }),
    chatBoxes: updateItem<ChatBoxModel>(
      (c) => c.conversationId === conversation._id,
      patch<ChatBoxModel>({
        conversation: patch<ConversationItem>({ ...conversation })
      })
    )
  });

export const createDraftChatBoxItem = (chatBoxId: string, payload: ChatOpenConversationParams): ChatBoxModel => {
  const conversationTempId = uniqueId('tempId_');
  return {
    id: chatBoxId,
    conversationId: conversationTempId,
    conversation: {
      _id: conversationTempId,
      createdAt: new Date(),
      updatedAt: new Date(),
      type: ConversationTypeEnum.PublicGroup,
      rooms: [],
      status: 'open',
      reference: payload.reference,
      referenceId: payload.referenceId,
      markAsSeenAt: new Date(0),
      participants: [],
      __v: 0
    },
    messages: [],
    isDraft: true,
    loadState: new DataLoadStatusModel('completed'),
    messagesLoadState: new DataLoadStatusModel('completed'),
    messagesisInitialLoad: true,
    messagesCanLoadMore: false
  };
};
